<template>
  <v-dialog :value="true" max-width="800" persistent>
    <v-card>
      <v-card-title class="headline">Adicionar Renegociação</v-card-title>
      <v-card-text v-if="savingItems.length > 0" class="pt-4">
        <v-list>
          <v-list-item v-for="item in savingItems" :key="item.date">
            <v-list-item-icon>
              <v-progress-circular v-if="item.saving" indeterminate :size="24" color="primary" />
              <v-icon v-else-if="item.result === 'ok'">mdi-check</v-icon>
              <v-icon v-else-if="item.result === 'error'">mdi-close</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ item.date | moment('MMMM/YYYY') }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card-text>
      <v-card-text v-else class="pt-4">
        <v-alert type="error" v-if="errorMessage" class="mb-6">{{ errorMessage }}</v-alert>
        <v-form ref="form" @submit.prevent>
          <v-row>
            <v-col cols="12" sm="6" class="py-0">
              <v-autocomplete
                label="Arrecadação *"
                v-model="fields.joined_id.value"
                :rules="[...fields.joined_id.rules, ...fields.joined_id.apiErrors]"
                :items="joineds"
                @input="fields.joined_id.apiErrors = []; concatDescription()"
                outlined dense
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" class="py-0">
              <v-autocomplete
                label="Categoria *"
                v-model="fields.category.value"
                :rules="[...fields.category.rules, ...fields.category.apiErrors]"
                :items="fields.category.options"
                @input="fields.category.apiErrors = []; concatDescription()"
                outlined dense
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="8" class="py-0">
              <v-text-field
                label="Descrição *"
                v-model="fields.description.value"
                :rules="[...fields.description.rules, ...fields.description.apiErrors]"
                type="text"
                @input="fields.description.apiErrors = []"
                outlined dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" class="py-0">
              <decimal-number
                label="Valor *"
                v-model="fields.installment_amount.value"
                :rules="[...fields.installment_amount.apiErrors]"
                @input="fields.installment_amount.apiErrors = []"
                outlined dense
              ></decimal-number>
            </v-col>
            <v-col cols="12" sm="12" class="py-0">
              <small>Competência</small>
              <br>
              <v-treeview
                v-if="dateItems.length > 0"
                selectable
                v-model="dates"
                :items="dateItems"
              ></v-treeview>
              <div v-else>O cliente precisa ter parcelas nessa arrecadação.</div>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn v-if="savingItems.length === 0" color="default" :disabled="saving" text @click="$emit('canceled')">
          Cancelar
        </v-btn>
        <v-btn v-if="savingItems.length === 0" color="success" :disabled="saving || dateItems.length === 0" :loading="saving" text @click="initSaveItems()">
          Salvar
        </v-btn>
        <v-btn v-if="savingItems.length > 0" color="success" :disabled="saving" :loading="saving" text @click="$emit('finished')">
          Ok
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios'
import { mapMutations } from 'vuex'
import DecimalNumber from '@/components/DecimalNumber'

export default {
  name: 'addRenegotiation',
  components: {
    DecimalNumber
  },
  props: {
    joineds: {
      required: true,
      type: Array
    },
    selectedJoined: {
      type: String,
      default: null
    },
    allowedDates: {
      required: true,
      type: Object
    }
  },
  data: () => ({
    fields: {
      category: {
        value: '',
        options: [
          { value: 'interest_and_fines', text: 'Multa/juros' },
          { value: 'renegotiation', text: 'Renegociação' },
          { value: 'additional', text: 'Adicional' },
          { value: 'discount', text: 'Desconto' }
        ],
        rules: [
          v => !!v || 'A categoria é obrigatória'
        ],
        apiErrors: []
      },
      joined_id: {
        value: '',
        options: [],
        rules: [
          v => !!v || 'A arrecadação é obrigatória'
        ],
        apiErrors: []
      },
      description: {
        value: '',
        rules: [
          v => !!v || 'A descrição é obrigatória'
        ],
        apiErrors: []
      },
      installment: {
        value: 1,
        rules: [
          v => !!v || 'A indicação da parcela é obrigatória'
        ],
        apiErrors: []
      },
      installment_amount: {
        value: 0,
        rules: [
          v => !!v || 'O valor é obrigatório'
        ],
        apiErrors: []
      }
    },
    dates: [],
    saving: false,
    savingItems: [],
    errorMessage: null
  }),
  computed: {
    dateItems () {
      const monthList = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro']
      const items = []
      if (this.fields.joined_id.value && this.allowedDates[this.fields.joined_id.value] && this.allowedDates[this.fields.joined_id.value].length > 1) {
        for (let i = 1; i < this.allowedDates[this.fields.joined_id.value].length; i++) {
          const date = this.allowedDates[this.fields.joined_id.value][i]
          const yearIndex = items.findIndex(e => e.id === date.year)
          if (yearIndex < 0) {
            items.push({
              id: date.year,
              name: date.year,
              locked: true,
              children: [
                { id: date.value, name: monthList[date.month - 1] }
              ]
            })
          } else {
            items[yearIndex].children.push({ id: date.value, name: monthList[date.month - 1] })
          }
        }
      }
      return items
    }
  },
  methods: {
    ...mapMutations(['SET_SNACKBAR']),
    generateApiErrors (apiErrors) {
      for (let key in apiErrors) {
        if (this.fields[key]) this.fields[key].apiErrors = apiErrors[key]
      }
    },
    concatDescription () {
      let description = ''
      if (this.fields.category.value) description += this.fields.category.options.filter(e => { return e.value === this.fields.category.value })[0].text + ' - '
      if (this.fields.joined_id.value) description += this.joineds.filter(e => { return e.value === this.fields.joined_id.value })[0].text + ' - '
      this.fields.description.value = description
    },
    initSaveItems () {
      if (this.$refs.form.validate()) {
        this.saving = true
        this.savingItems = this.dates.map(e => {
          return {
            date: e,
            saving: false,
            result: null
          }
        })
        this.saveItems()
      } else {
        this.errorMessage = 'Verifique os campos com erro'
      }
    },
    apiData (dueDate) {
      let data = {}
      for (let key in this.fields) {
        if (this.fields[key].value) data[key] = this.fields[key].value
      }
      data.installment = this.savingItems.length
      data.due_date = dueDate
      return data
    },
    async saveItems () {
      if (this.savingItems.length > 0) {
        // const promises = []
        for (let i = 0; i < this.savingItems.length; i++) {
          const item = this.savingItems[i]
          const itemIndex = this.savingItems.findIndex(e => e.date === item.date)
          this.$set(this.savingItems[itemIndex], 'saving', true)
          try {
            await axios.post('financial-negotiations', this.apiData(item.date))
            this.$set(this.savingItems[itemIndex], 'saving', false)
            this.$set(this.savingItems[itemIndex], 'result', 'ok')
          } catch (e) {
            this.$set(this.savingItems[itemIndex], 'saving', false)
            this.$set(this.savingItems[itemIndex], 'result', 'error')
          }
        }
        this.saving = false
      } else {
        this.saving = false
      }
    }
  },
  created () {
    if (this.joineds) {
      if (this.selectedJoined) this.fields.joined_id.value = this.selectedJoined
    } else {
      this.SET_SNACKBAR({ text: 'Houve um erro ao processar seu pedido. Tente novamente.' })
      this.$emit('error')
    }
  }
}
</script>
